import {
  ErrorPanel,
  FullScreenOverlay,
  LoadingIndicator,
} from '@nbirl/nbi-common-ui-libs';
import { FormikHelpers } from 'formik';

import { Role } from '../../shared/enum';
import { useErrorToast } from '../../shared/hooks';
import { BaseLayout } from '../../shared/layout';
import { ApiError } from '../../shared/models';
import { useRootFoldersQuery } from '../resources/folders/queries';
import { UserForm, UserFormValues, UserSaveSuccessModal } from './components';
import { useAddUserMutation } from './queries';

export const AddUser = () => {
  const foldersQuery = useRootFoldersQuery();
  const addUserMutation = useAddUserMutation();
  const { showErrorToast } = useErrorToast();

  const handleSubmit = async (
    values: UserFormValues,
    formikHelpers: FormikHelpers<UserFormValues>
  ) => {
    const { folderIds } = values;

    try {
      await addUserMutation.mutateAsync({
        ...values,
        folderIds: values.role === Role.FullAdmin ? [] : folderIds,
      });
    } catch (error) {
      if (error instanceof ApiError && error.code === '02002') {
        formikHelpers.setFieldError(
          'email',
          'A user with that email already exists'
        );
      } else if (error instanceof ApiError && error.code === '02004') {
        formikHelpers.setFieldError(
          'mobileNumber',
          'Invalid mobile phone number'
        );
      } else {
        showErrorToast('Unable to add new user. Please try again.');
      }
    }
  };

  if (foldersQuery.isLoading) {
    return (
      <FullScreenOverlay>
        <LoadingIndicator />
      </FullScreenOverlay>
    );
  }

  if (foldersQuery.isError) {
    return (
      <FullScreenOverlay>
        <ErrorPanel error={foldersQuery.error} />
      </FullScreenOverlay>
    );
  }

  return (
    <BaseLayout>
      <UserForm onSubmit={handleSubmit} folders={foldersQuery.data ?? []} />
      {addUserMutation.data && (
        <UserSaveSuccessModal
          heading="User Added"
          user={addUserMutation.data}
        />
      )}
    </BaseLayout>
  );
};
